module.exports = __webpack_public_path__ + "static/one-3a0f54b83df2e5cd217edd61826a6b86.png";